export const burgerActionTypes = {
    HAMBURGER_MENU: "HAMBURGER_MENU",
    CLOSE_MENU: "CLOSE_MENU"
};